export default __webpack_public_path__ + "static/manifold_b.7b68a482019f7d5102be9943d18a836d.png";